import { createContext, useContext } from 'react';

export type ShowToast = (message: string) => void;

export const ToastContext = createContext<ShowToast>(() => {});

/** Show a short confirmation at the bottom of the screen (ToastProvider). */
export function useToast(): ShowToast {
  return useContext(ToastContext);
}
